import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, NO_CONTENT, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { deleteFileFailed, deleteFileSuccessful } from '../actions';

export default function* deleteFile(action) {
  try {
    const url = `${BACKEND_URL}/resources/media-files/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteFileSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteFileFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteFileFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
